import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import Styles from './vm-label.scss';

export type VmLabelVariant = 'default' | 'primary';

/**
 * Small pill-shaped label.
 *
 * @attr variant - Colour scheme. '`default` or `primary`.
 */
@customElement('vm-label')
export class VmLabel extends LitElement {
    static override styles = Styles;

    @property({ type: String, reflect: true }) variant: VmLabelVariant = 'default';

    override render() {
        return html`<span class="vm-label"><slot></slot></span>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-label': VmLabel;
    }
}
